import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { News } from '@fairandsmart/types';
import { CallState, FsOrgState } from '../../../reducers';
import { feed, newsToRead } from './news.reducer';
import {
  MarkNewsAsRead, MarkNewsAsUnread, RefreshNews, ShowNews,
} from './news.actions';

@Injectable()
export class NewsService {
  private store = inject<Store<FsOrgState>>(Store);

  public newsToRead$: Observable<number>;

  public feed$: Observable<{ collection: News[], state: CallState }>;

  constructor() {
    this.newsToRead$ = this.store.select(newsToRead);
    this.feed$ = this.store.select(feed);
  }

  public showNews(): void {
    this.store.dispatch(new ShowNews());
  }

  public refreshNews(): void {
    this.store.dispatch(new RefreshNews());
  }

  public markAsRead(newsId: string) {
    this.store.dispatch(new MarkNewsAsRead({ newsId }));
  }

  public markAsUnread(newsId: string) {
    this.store.dispatch(new MarkNewsAsUnread({ newsId }));
  }
}
